import { isPlainObject, isString } from 'lodash'

/** Longest argument shown in a tool row before it is cut with an ellipsis. */
const MAX_ARGUMENT_LENGTH = 48

/** Input keys whose value says what a call did, in order of preference; `operationId` reads best bare. */
const LABEL_ARGUMENTS = ['q', 'query'] as const

/**
 * What a tool call ran, as `query(getChargers)` or `list_operations(q=chargers)`: the tool name with the
 * operation id, or else its search argument, from the call's input. A call with neither shows the bare name.
 */
export default function toolCallLabel(name: string, input: unknown): string {
  if (!isPlainObject(input)) return name
  const args = input as Record<string, unknown>
  if (isString(args.operationId) && args.operationId) return `${name}(${truncate(args.operationId)})`
  const key = LABEL_ARGUMENTS.find((candidate) => isString(args[candidate]) && args[candidate])
  return key ? `${name}(${key}=${truncate(String(args[key]))})` : name
}

/**
 * Tools the transcript leaves out: `list_operations` is the model looking up which API operations exist, which tells
 * the operator nothing about what it did. The stored message keeps these calls; only their rendering is skipped.
 */
const HIDDEN_TOOLS: ReadonlySet<string> = new Set(['list_operations'])

export function isHiddenTool(name: string): boolean {
  return HIDDEN_TOOLS.has(name)
}

function truncate(value: string): string {
  return value.length > MAX_ARGUMENT_LENGTH ? `${value.slice(0, MAX_ARGUMENT_LENGTH - 1)}…` : value
}
